<template>
  <div
    class="flex flex-col justify-center items-center pt-32 text-gray-600"
  >
    <OImage v-bind="image" />
    <h1 class="ota-h1 mb-2 mt-20" v-text="$t('Error.404.title')" />
    <p class="ota-body" v-text="$t('Error.404.description')" />
    <div class="text-center pt-12">
      <OButton
        tag="nuxt-link"
        to="/"
      >
        {{ $t('Error.404.button') }}
      </OButton>
    </div>
  </div>
</template>

<script>
import { getImagePaths } from '@/utils/general'
import OImage from '@/components/OImage'
import OButton from '@/components/OButton'

export default {
  name: 'PageNotFoundError',
  components: { OImage, OButton },
  props: {
    error: {
      type: Object,
      default: () => ({ statusCode: 404, message: 'Page not found' })
    }
  },
  layout: 'minimal',
  computed: {
    image () {
      return getImagePaths(
        {
          path: '/img/error/404',
          s3: false
        }
      )
    }
  },
  created () {
    if (this.error.message === 'Page not found' || this.error.statusCode === 404) {
      this.$nuxt.error({ statusCode: 404, message: 'Page not found' })
    } else {
      this.$nuxt.error({ statusCode: this.error.statusCode, message: this.error.message })
    }
  }
}
</script>
